import { getTranslationDashboardElements } from './translationDashboardElements.js'
import dropdownConfig from './translationDashboardOptions.json'
import { initTranslationDashboardDropdowns } from './utils.js'

const { TD_DROPDOWN_SELECTOR, TD_DROPDOWN_MENU_SELECTOR, TD_DROPDOWN_TEXT_SELECTOR, TD_DROPDOWN_ITEM_CLASS, DATA_VALUE_ATTRIBUTE } =
  getTranslationDashboardElements()

function setEmptyDropdownLabel(labelElement) {
  if (!labelElement) {
    return
  }
  labelElement.innerHTML = '<span class="cmp-filterbar__dropdown-button--desktop-label"></span>'
}

function createPlaceholderOption(isSelected = true) {
  const option = document.createElement('option')
  option.value = ''
  option.hidden = true
  if (isSelected) {
    option.selected = true
  }
  option.textContent = '-'
  return option
}

function getWebsiteConfig(websiteValue) {
  if (!dropdownConfig || !Array.isArray(dropdownConfig.websites)) {
    return null
  }
  return dropdownConfig.websites.find(site => site.value === websiteValue) || null
}

function updateSectionDropdownSelection({ sectionSelect, label, sections, placeholderOption, keepCurrentSelection, previousValue }) {
  let newValue = ''
  if (keepCurrentSelection && sections.some(section => section.value === previousValue)) {
    newValue = previousValue
  }

  if (newValue) {
    sectionSelect.value = newValue
    placeholderOption.selected = false
    const selectedConfig = sections.find(section => section.value === newValue) || null
    label.textContent = selectedConfig ? selectedConfig.label : ''
    if (!selectedConfig) {
      setEmptyDropdownLabel(label)
    }
  } else {
    sectionSelect.value = ''
    setEmptyDropdownLabel(label)
  }
}

export function populateWebsiteDropdown(websiteSelect) {
  const websiteDropdown = websiteSelect ? websiteSelect.closest(TD_DROPDOWN_SELECTOR) : null
  if (!websiteSelect || !websiteDropdown || !dropdownConfig || !Array.isArray(dropdownConfig.websites)) {
    return
  }

  const menu = websiteDropdown.querySelector(TD_DROPDOWN_MENU_SELECTOR)
  const label = websiteDropdown.querySelector(TD_DROPDOWN_TEXT_SELECTOR)
  if (!menu || !label) {
    return
  }

  websiteSelect.innerHTML = ''
  const placeholderOption = createPlaceholderOption(false)
  websiteSelect.appendChild(placeholderOption)

  menu.innerHTML = ''

  const defaultWebsite = dropdownConfig.websites.find(site => site.value === 'hitachi-energy') || dropdownConfig.websites[0] || null

  dropdownConfig.websites.forEach(site => {
    const opt = document.createElement('option')
    opt.value = site.value
    opt.textContent = site.label
    websiteSelect.appendChild(opt)

    const li = document.createElement('li')
    li.className = TD_DROPDOWN_ITEM_CLASS
    li.setAttribute(DATA_VALUE_ATTRIBUTE, site.value)
    li.textContent = site.label
    menu.appendChild(li)
  })

  if (defaultWebsite) {
    websiteSelect.value = defaultWebsite.value
    label.textContent = defaultWebsite.label
  } else {
    websiteSelect.value = ''
    setEmptyDropdownLabel(label)
  }
}

export function populateSectionDropdownForWebsite(websiteValue, keepCurrentSelection = false) {
  const sectionSelect = document.getElementById('dynamicPartSelect')
  const sectionDropdown = sectionSelect ? sectionSelect.closest(TD_DROPDOWN_SELECTOR) : null
  if (!sectionSelect || !sectionDropdown) {
    return
  }

  const menu = sectionDropdown.querySelector(TD_DROPDOWN_MENU_SELECTOR)
  const label = sectionDropdown.querySelector(TD_DROPDOWN_TEXT_SELECTOR)
  if (!menu || !label) {
    return
  }

  const websiteConfig = getWebsiteConfig(websiteValue)
  const sections = websiteConfig && Array.isArray(websiteConfig.sections) ? websiteConfig.sections : []

  const previousValue = keepCurrentSelection ? sectionSelect.value : ''

  sectionSelect.innerHTML = ''
  const placeholderOption = createPlaceholderOption(true)
  sectionSelect.appendChild(placeholderOption)

  menu.innerHTML = ''

  sections.forEach(section => {
    const opt = document.createElement('option')
    opt.value = section.value
    opt.textContent = section.label
    sectionSelect.appendChild(opt)

    const li = document.createElement('li')
    li.className = TD_DROPDOWN_ITEM_CLASS
    li.setAttribute(DATA_VALUE_ATTRIBUTE, section.value)
    li.textContent = section.label
    menu.appendChild(li)
  })

  updateSectionDropdownSelection({ sectionSelect, label, sections, placeholderOption, keepCurrentSelection, previousValue })

  const hasOptions = sections.length > 0
  sectionSelect.disabled = !hasOptions
  sectionDropdown.classList.toggle('td-dropdown--disabled', !hasOptions)
}
export function resetSearchInput(searchInput) {
  if (searchInput) {
    searchInput.value = ''
  }
}

export function resetFilter() {
  const sectionSelect = document.getElementById('dynamicPartSelect')
  const sectionDropdown = sectionSelect ? sectionSelect.closest(TD_DROPDOWN_SELECTOR) : null
  const searchInput = document.querySelector('.cmp-translation-search-input')
  const itemsPerPageSelect = document.getElementById('itemsPerPage')
  const statusAllRadio = document.querySelector('input[name="translate_status"][value="all"]')

  if (sectionSelect && sectionDropdown) {
    const sectionMenu = sectionDropdown.querySelector(TD_DROPDOWN_MENU_SELECTOR)
    const sectionLabel = sectionDropdown.querySelector(TD_DROPDOWN_TEXT_SELECTOR)

    sectionSelect.innerHTML = ''
    const placeholderOption = createPlaceholderOption(true)
    sectionSelect.appendChild(placeholderOption)

    if (sectionMenu) {
      sectionMenu.innerHTML = ''
    }
    if (sectionLabel) {
      setEmptyDropdownLabel(sectionLabel)
    }
  }
  if (itemsPerPageSelect) {
    itemsPerPageSelect.value = '10'
  }

  if (statusAllRadio) {
    statusAllRadio.checked = true
  }
  resetSearchInput(searchInput)
  populateSectionDropdownForWebsite(document.getElementById('websiteSelect').value)
  clearAndHideSubSectionDropdown()
}
export function clearAndHideSubSectionDropdown() {
  const buSelect = document.getElementById('pagePropertyInput')
  const buDropdown = buSelect ? buSelect.closest(TD_DROPDOWN_SELECTOR) : null
  const subSectionWrapper = document.querySelector('.wrapper-dropdown--sub-section')

  if (!buSelect || !buDropdown) {
    if (subSectionWrapper) {
      subSectionWrapper.style.visibility = 'hidden'
    }
    return
  }

  const menu = buDropdown.querySelector(TD_DROPDOWN_MENU_SELECTOR)
  const label = buDropdown.querySelector(TD_DROPDOWN_TEXT_SELECTOR)

  buSelect.innerHTML = ''
  const placeholderOption = createPlaceholderOption(true)
  buSelect.appendChild(placeholderOption)

  if (menu) {
    menu.innerHTML = ''
  }
  if (label) {
    setEmptyDropdownLabel(label)
  }

  if (subSectionWrapper) {
    subSectionWrapper.style.visibility = 'hidden'
  }
}

export function populateSubSectionDropdownForSection(sectionValue) {
  const buSelect = document.getElementById('pagePropertyInput')
  const buDropdown = buSelect ? buSelect.closest(TD_DROPDOWN_SELECTOR) : null
  const subSectionWrapper = document.querySelector('.wrapper-dropdown--sub-section')

  if (!buSelect || !buDropdown || !subSectionWrapper) {
    return
  }

  const menu = buDropdown.querySelector(TD_DROPDOWN_MENU_SELECTOR)
  const label = buDropdown.querySelector(TD_DROPDOWN_TEXT_SELECTOR)
  if (!menu || !label) {
    return
  }

  buSelect.innerHTML = ''
  const placeholderOption = createPlaceholderOption(true)
  buSelect.appendChild(placeholderOption)

  menu.innerHTML = ''

  const sectionSubSections =
    dropdownConfig && dropdownConfig.subSections && Array.isArray(dropdownConfig.subSections[sectionValue])
      ? dropdownConfig.subSections[sectionValue]
      : []

  sectionSubSections.forEach(sub => {
    const opt = document.createElement('option')
    opt.value = sub.value
    opt.textContent = sub.label
    buSelect.appendChild(opt)

    const li = document.createElement('li')
    li.className = TD_DROPDOWN_ITEM_CLASS
    li.setAttribute(DATA_VALUE_ATTRIBUTE, sub.value)
    li.textContent = sub.label
    menu.appendChild(li)
  })

  setEmptyDropdownLabel(label)
  subSectionWrapper.style.visibility = sectionSubSections.length ? 'visible' : 'hidden'

  // Re-initialize dropdown behavior for new items
  initTranslationDashboardDropdowns()
}

export function handleSectionChange(select, productSolutionsValue) {
  if (!select) {
    return
  }

  if (select.value === productSolutionsValue) {
    populateSubSectionDropdownForSection(productSolutionsValue)
  } else {
    clearAndHideSubSectionDropdown()
  }
}
